'use strict';

app.provider('$popup', function () {

  var popups = {};

  this.define = function (name, conf) {
    popups[name] = conf;
  };

  this.$get = function ($modal, $timeout, $rootScope) {
    return function (name, params) {
      var opts = popups[name](params || {});
      opts.scope = (this instanceof $rootScope.constructor) ? this : $rootScope;
      return $modal.open(opts).result.finally(function () {
        $('.modal:last').trigger('$animate:close');
        $timeout(function () {
          $('.modal-backdrop:last').trigger('$animate:close');
        }, 50, false);
      });
    };
  };

});

app.config(function ($popupProvider) {
  $popupProvider.define('prompt', function (params) {
    return /*@ngInject*/ {
      windowClass: 'prompt-modal',
      template: [
        '<div class="prompt">',
          '<div class="prompt-body" ng-bind-html="params.message"></div>',
          '<div class="prompt-footer">',
            '<button class="btn btn-go" ng-click="$dismiss()">{{ params.reject || "Ok" }}</button> ',
            '<button class="btn btn-active" ng-click="$close()" ng-if="params.resolve">{{ params.resolve }}</button>',
          '</div>',
        '</div>'
      ].join(''),
      controller: function ($scope) {
        $scope.params = params;
      }
    };
  });
});

app.config(function ($popupProvider) {
  $popupProvider.define('video', function (video) {
    return /*@ngInject*/ {
      windowClass: 'video-modal',
      template: '<div rm-video="video" autoplay="true"></div>',
      controller: function ($scope) {
        $scope.video = video;
      }
    };
  });
});

app.run(function ($rootScope, $modalStack) {
  $rootScope.$on('$locationChangeStart', function (event) {
    var modal = $modalStack.getTop();
    if (modal) {
      event.preventDefault();
      modal.key.dismiss();
    }
  });
});

app.run(function ($rootScope, $popup) {
  $rootScope.$popup = $popup;
});
